import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

type ChangeUserinfoType = {
  nickname: string;
  email: string;
};

export const changeUserinfo = ({ nickname, email }: ChangeUserinfoType) => {
  return axios.put('/api/auth/userinfo', { email, nickname });
};

export const useChangeUserinfo = () => {
  return useMutation({
    mutationFn: ({ email, nickname }: ChangeUserinfoType) =>
      changeUserinfo({ email, nickname }),
  });
};
